import { FieldValidator } from './field-validator'

export class NotBlankStateFieldValidator implements FieldValidator<string> {
    constructor(private errorMessage = 'cannot be blank') {}

    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            if (text === undefined || text === '' || text === null || text === '0') {
                reject(`${fieldName} ${this.errorMessage}`)
            } else {
                resolve('')
            }
        })
    }
}
